import React, { memo } from 'react'
import { useRecoilValue } from 'recoil'
import {
  currentSection as currentSectionState,
} from '../store/uiStore'
import '../assets/styles/animations.scss';
import Polygon from '../assets/svg/Polygon'

const Background = () => {
  const currentSection = useRecoilValue(currentSectionState)
  return (
    <div className={`${currentSection} main-bg`}>
      <div className='polygon'>
        <Polygon section={currentSection} />
      </div>
    </div>
  )
}

export default memo(Background)
